module.exports = __webpack_public_path__ + "img/qudao1.37bf47ea.png";